import { writable } from "svelte/store";

let stored_workspace_id = localStorage.getItem("workspace_id");

if (!stored_workspace_id) {
    localStorage.setItem("workspace_id", "");
    stored_workspace_id = localStorage.getItem("workspace_id");
}

export const workspace_id = writable(stored_workspace_id);

workspace_id.subscribe(value => {
    localStorage.setItem("workspace_id", value ? value : '');
});